import { VueExtension } from '../../utils/extensions/vue';
import Step from './step.jsx';
import './step.scss';

VueExtension.WithInstall(Step);

export default Step;
